import { DataBean } from "../DataBean";

export class CreateMoneyBase extends DataBean {


    public async createMoneyBaseForCashDeskAccount(idCashDeskAccount:any,idBankingAccount:any,observations:any,value:any,accountantDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createMoneyBaseForCashDeskAccount_Number_Number_String_Number_java.util.Date_Number", [idCashDeskAccount,idBankingAccount,observations,value,accountantDate,idEmployee]);
    }

}